import { FormattedMessage } from 'react-intl';
import WarningIcon from '@atlaskit/icon/core/warning';
import { IconTile } from '@atlaskit/icon';

import IconWithContent from '../IconWithContent';
import { useInfo } from '../../../Flow/ConsentContextProvider';

const PrivacyCompliance = () => {
  const { client } = useInfo();
  const pollsPrivacyApi =
    client?.lastGdprPollTime &&
    Date.now() < client.lastGdprPollTime + 14 * 24 * 60 * 60 * 1_000;

  // If the developer has not answered whether they store user data
  // OR if the app does store user data and has not been polling the privacy API
  if (
    client?.appStoresUserData == null ||
    (client.appStoresUserData && !pollsPrivacyApi)
  ) {
    return (
      <IconWithContent
        icon={
          <IconTile
            icon={WarningIcon}
            label=""
            appearance="gray"
            size="medium"
          />
        }
        text={
          <FormattedMessage
            id="trello.vendor.privacyGuidelinesWarning"
            defaultMessage="This app does not follow Atlassian’s privacy guidelines. By authorizing access <strong>you may be putting your personal data at risk</strong>."
            description="Warning about not following privacy guidelines"
            values={{
              strong: (text) => <strong>{text}</strong>,
            }}
          />
        }
      />
    );
  }

  return <></>;
};

export default PrivacyCompliance;
